import React from 'react';
import { Typography, styled } from '@mui/material';

export const StyledTypography = styled(Typography)({
  '& span': {
    background: 'var(--Brand-Cadet-Blue, linear-gradient(138deg, #6599A5 24.11%, #3B667E 83.2%))',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
});

export type TypographyVariant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'subtitle1'
  | 'subtitle2'
  | 'body1'
  | 'body2'
  | 'caption'
  | 'button'
  | 'overline'
  | 'bodyBold'
  | 'title2Bold'
  | 'subheadBold'
  | 'title1Bold';

interface StyledSpanProps {
  variant?: TypographyVariant;
  textAlign?: 'inherit' | 'left' | 'center' | 'right' | 'justify';
  color?: string;
  children: string;
}

function StyledSpan({ variant, textAlign, color, children }: StyledSpanProps) {
  return (
    <StyledTypography variant={variant} textAlign={textAlign} color={color}>
      <span>{children}</span>
    </StyledTypography>
  );
}

StyledSpan.defaultProps = {
  variant: 'bodyBold',
  textAlign: 'center',
  color: 'primary.main',
};

export default StyledSpan;
